<template>
    <div class="pm-gallery-media-list" style="padding-top: 12px;" :key="tagsUpdated">

        <section v-for="(tag, tagIdx) in tags" v-if="items[tag] && (items[tag].length > 0 || (isDev && tag!=='favourites'))" :key="tag" class="renderfix" style="background: #fff; margin-bottom: 0px; padding-bottom: 0px;">

                <div :class="isDev ? '' : 'pm-animation-fade-in-slide-down'" class="grey--text text--darken-1 gallery--title" style="text-transform: lowercase; font-style: italic; text-align: center; background: #fff; z-index: 2; font-size: 12px; padding: 4px 16px 4px 16px; font-weight: 600" :style="'--delay: '+Math.ceil((tagIdx[tag]+1)) * 20+'ms'">
                    <template v-if="!isDev && tag === 'favourites'"><mdi size="18">heart-outline</mdi></template>
                    <template v-if="!isDev && tag === 'Before-After'"><mdi size="18">emoticon-happy-outline</mdi></template>
                    <template v-if="isDev">
                        <v-text-field :readonly="['Before-After', 'deleted','favourites','unused'].includes(tag)" :value="tag" @blur="(e) => renameTag(tag, e.target.value)" />
                        <span style="float: right; position: relative; right: 0; border-radius: 4px; margin: -50px 0 0 0; padding: 5px; background: #eee;" @click="exportGroup(tag)">export</span>
                    </template>
                    <template v-else>
                        {{ tag.charAt(0).toUpperCase() + tag.slice(1) }}
                    </template>
                </div>

                 <draggable :disabled="!isDev" :sort="tag!=='x'" :data-tag="tag" v-model="items[tag]" group="tag" @add="addToList" @end="onEnd" class="pm-gallery-media-grid" :id="'list_' + tag" style="margin-bottom: 10px; margin-top: -4px;">

                        <div v-for="(item, idx) in items[tag]" :data-tag="tag" :data-src="item.src" :data-id="item.id" :id="'pm-gallery-media-grid-thumb-' + item.id" :class="isDev ? '' : 'pm-animation-fade-in-slide-down'" class="renderfix editable pm-gallery-media-grid-thumb"
                             @click="view(item, idx, tag)" :key="item.id + item.src"
                            :style="'--delay: '+Math.ceil((tagIdx[tag]+idx+1)) * 20+'ms;'+'background-image: url('+getBgImage(item)+');'"
                             @contextmenu="(e) => showContext(e, item)"
                        >
                            <mdi
                                :style="dupeCounter[item.src] > 1 ? 'background: #f00!important; color: #fff;' : ''"

                                @click.native.stop="setTag('deleted', item)" style="display: block; position: absolute; right: 5px; top: 5px; cursor: pointer; background: rgba(255,255,255,.75); padding: 3px;" v-if="isDev">trash-can-outline</mdi>


                            <!-- <div @click.native.stop="showUpgrade" style="display: flex; justify-content: center; align-items: center; position: absolute; right: 0px; top: 0px; left: 0; bottom: 0; cursor: pointer; background: rgba(150,150,150,.7); padding: 3px; border-radius: 3px;" v-if="!$IAP.hasAccessToComponent('photos')">
                                <div style="padding-top: 5px; text-align: center; font-size: 9px; color: #fff!important; font-weight: 600; line-height: 2;" class="gallery--premium-badge">
                                    <mdi style="color: #fff!important;">lock</mdi><br/>
                                    PREMIUM
                                </div>
                            </div> -->
                        </div>
                 </draggable>
        </section>
        <br/>

        <div v-if="isDev" style="text-align: center">
            <v-btn outline style="border: 2px solid #ddd!important; border-radius: 12px;" @click="createTag">New group</v-btn>
            <br/><br/>
        </div>

        <v-menu v-model="showContextMenu" :position-x="contextMenuX" :position-y="contextMenuY" absolute offset-y>
            <div class="tagContextMenu" style="padding: 3px 0;">
                <div v-for="tag in tags" v-if="tag!=='favourites'" :key="tag" @click.stop="setTag(tag, contextMenuItem)">
                    {{ tag }}
                </div>
            </div>
        </v-menu>

        <input v-if="isDev" type="text" value="" id="clipboardInput">
    </div>
</template>
<style>
.tagContextMenu div {
    border-bottom: 1px solid #eee; font-size: 11px; padding: 4px 10px; cursor: pointer;
}
.tagContextMenu div:hover {
    background: #ddd;
}
.pm-zoom-in-transition-leave-active {
    transition: opacity .3s, transform .4s;
}

.pm-zoom-in-transition-enter-active {
    transition: opacity .6s, transform .4s;
}

.pm-zoom-in-transition-enter-to {
    opacity: 1;
    transform: scale(1);
}

.pm-zoom-in-transition-enter, .pm-zoom-in-transition-leave-to {
    opacity: 0;
    transform: scale(0.1);
}


    .pm-gallery-media-grid {
        display: grid;
        gap: 16px;
        background: none;
        padding: 8px 16px 0px 16px;
    }
    .pm-gallery-grid-4 .pm-gallery-media-grid {
        grid-template-columns: repeat(4, 4fr);
        padding: 8px 16px 0px 16px;
        gap: 16px;
    }
    .pm-gallery-grid-8 .pm-gallery-media-grid {
        grid-template-columns: repeat(8, 8fr);
        padding: 8px 16px 0px 16px;
        gap: 16px;
    }
    .pm-gallery-grid-3 .pm-gallery-media-grid {
        grid-template-columns: repeat(3, 3fr);
    }
    .pm-gallery-grid-2 .pm-gallery-media-grid {
        grid-template-columns: repeat(2, 2fr);
    }
    .pm-gallery-grid-1 .pm-gallery-media-grid {
        grid-template-columns: repeat(1, 1fr);
    }
    .pm-gallery-media-grid-thumb {
        will-change: transform, opacity;
        background-color: #eee;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 3px;
        box-shadow: 2px 2px 3px rgba(0,0,0,.15);
    }
    .pm-gallery-grid-8 .pm-gallery-media-grid-thumb {
        height: Calc(100vw / 8 - 12px);
    }
    .pm-gallery-grid-4 .pm-gallery-media-grid-thumb {
        height: Calc(100vw / 4 - 24px);
    }
    .pm-gallery-grid-3 .pm-gallery-media-grid-thumb {
        height: Calc(100vw / 3 - 28px);
    }
    .pm-gallery-grid-2 .pm-gallery-media-grid-thumb {
        height: Calc((100vw / 2) - 32px);
    }
    .pm-gallery-grid-1 .pm-gallery-media-grid-thumb {
        height: Calc(100vw - 32px);
    }

@media (min-width: 700px) {
    .gallery--title {
        font-size: 16px !important;
    }

    .gallery--premium-badge {
        font-size: 16px !important;
    }

    .gallery--premium-badge svg {
        width: 40px;
        height: 40px;
    }
}
</style>
<script>
import MediaList from "../../configs/gallery/media";
// import UpdatedMediaList from "../../configs/gallery/media.js";
const UpdatedMediaList = [];
window.MediaList = MediaList;
import galleryFavvedMixin from "./mixin-method-favved";

import draggable from 'vuedraggable';

const defaultGrid = 2;

export default {
    mixins: [
        galleryFavvedMixin,
    ],
    props: {
        id: {
            type: Number,
        },
    },
    components: {
        draggable,
    },
    data() {
        return({
            viewerVisible: false,
            tags: ["favourites", "unused", "deleted"],
            tagIdx: null,
            viewedItem: null,
            sortable: false,
            items: {},
            orderingUpdated: false,
            adShowed: false,
            isDev: false,
            showContextMenu: false,
            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuItem: {},
            tagsUpdated: 0,
            dupeCounter: {},
        });
    },
    computed: {
        is4in1() {
            return window.packageName === 'com.denticalc.4in1';
        },
    },
    created() {
        try {
            // this.isDev = (location.hostname === "localhost" || location.hostname.includes("192.168.0.") || location.hostname.includes("test.app."));
            this.isDev = false; // (location.hostname.includes("test.app."));
        } catch (e) {

        }

        this.items = this.getItems();

        this.$bus.$on('galleryGridToggled', () => {
            this.$forceUpdate();
        });
    },
    beforeDestroy() {
        if (this.adTimeout) window.clearTimeout(this.adTimeout);
    },
    deactivated() {
        this.adShowed = false;
        if (this.adTimeout) window.clearTimeout(this.adTimeout);
        this.adTimeout = null;
    },
    mounted() {
    },
    methods: {
        toClipboard(data) {
            const clipboardInput = document.getElementById("clipboardInput");
            clipboardInput.value = data + ";";
            clipboardInput.select();
            clipboardInput.setSelectionRange(0, 999999); /* For mobile devices */
            document.execCommand("copy");
        },
        exportGroup(tag) {
            const els = document.querySelectorAll('.pm-gallery-media-grid-thumb');
            const srcs = [];
            els.forEach(el => {
                 if (el.dataset.tag !== tag) return;
                 srcs.push(el.dataset.src);
            });
            console.log(JSON.stringify(srcs));
            this.toClipboard(JSON.stringify(srcs));
        },
        showUpgrade() {
            this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_photos_list' });
        },
        showContext(e, item) {
            this.contextMenuItem = item;
            e.preventDefault()
            this.showContextMenu = false;
            this.contextMenuX = e.clientX;
            this.contextMenuY = e.clientY;
            this.$nextTick(() => {
                this.showContextMenu = true
            });
        },

        createTag() {
            const tag = 'New_group_' + new Date().getTime();
            this.tags.push(tag);
            this.$set(this.items, tag, []);
            this.tagsUpdated++;

            this.items = this.getItems();

            this.$forceUpdate();
        },

        renameTag(oldTag, newTag) {
            if(oldTag === newTag) return;

            let overrideTagNames = {};
            if (localStorage.getItem('overrideTagNames')) overrideTagNames = JSON.parse(localStorage.getItem('overrideTagNames'));
            if (typeof(overrideTagNames[String(this.id)]) === 'undefined') overrideTagNames[String(this.id)] = {};

            // Use original tag names on consecutive renames
            let origTag = oldTag;
            Object.keys(overrideTagNames[String(this.id)]).forEach(key => {
               if(overrideTagNames[String(this.id)][key] === oldTag) origTag = key;
            });

            overrideTagNames[String(this.id)][origTag] = newTag;
            localStorage.setItem('overrideTagNames', JSON.stringify(overrideTagNames));

            let overrideTags = {};
            if (localStorage.getItem('overrideTags')) overrideTags = JSON.parse(localStorage.getItem('overrideTags'));
            this.items[oldTag].forEach(item => {
                if (typeof overrideTags[String(item.id)] !== 'undefined') overrideTags[String(item.id)] = newTag;
            });
            localStorage.setItem('overrideTags', JSON.stringify(overrideTags));

            this.items[oldTag].forEach(item => {
                item.tags = [newTag];
            });

            this.$nextTick(() => {
                this.items = this.getItems();
                this.tagsUpdated++;
                this.$forceUpdate();
            })
        },

        addToXItems(id) {
            let xItemOverride = {};
            if (localStorage.getItem('xItems')) xItemOverride = JSON.parse(localStorage.getItem('xItemOverride'));
            xItemOverride[String(id)] = this.id;
            localStorage.setItem('xItemOverride', JSON.stringify(xItemOverride));
        },

        removeFromXItems(id) {
            let xItemOverride = {};
            if (localStorage.getItem('xItems')) xItemOverride = JSON.parse(localStorage.getItem('xItemOverride'));
            xItemOverride[String(id)] = this.id;
            localStorage.setItem('xItemOverride', JSON.stringify(xItemOverride));
        },

        addToList(params) {
            if (params.item.dataset.tag === 'x') this.removeFromXItems(params.item.dataset.id);
            if (params.target.dataset.tag === 'x') this.addToXItems(params.item.dataset.id);
            let overrideTags = {};
            if (localStorage.getItem('overrideTags')) overrideTags = JSON.parse(localStorage.getItem('overrideTags'));
            overrideTags[String(params.item.dataset.id)] = params.target.dataset.tag;
            localStorage.setItem('overrideTags', JSON.stringify(overrideTags));
        },

        setTag(tag, item) {
            if (item.tags[0] === 'x') this.removeFromXItems(item.id);
            if (tag === 'x') this.addToXItems(item.id);
            let overrideTags = {};
            if (localStorage.getItem('overrideTags')) overrideTags = JSON.parse(localStorage.getItem('overrideTags'));
            overrideTags[String(item.id)] = tag;
            localStorage.setItem('overrideTags', JSON.stringify(overrideTags));
            this.items = this.getItems();
            this.showContextMenu = false;
            this.contextMenuItem = {};
        },

        onEnd(params) {
            this.updateOrdering(params.to.dataset.tag);

            console.log(
                'LEGUTOLSO_SORREND',
                localStorage.getItem('overrideTagNames'),
                localStorage.getItem('overrideTags'),
                localStorage.getItem('overrideOrdering'),
                localStorage.getItem('xItems'),
            );
        },

        getBgImage(item) {
            const rootUrl = "https://cdn.denticalc.com/photos/";
            const grid = localStorage.getItem('galleryGrid') ? localStorage.getItem('galleryGrid') : defaultGrid;
            if (grid <= 2) return rootUrl + item.src.replace('.jpg','_thumb_guetzli.jpg');

            const suffix = document.body.getBoundingClientRect().width > 600
                ? '_thumb_guetzli.jpg'
                : '_thumb_xs_guetzli.jpg';

            return rootUrl + item.src.replace('.jpg', suffix);


            return 'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_xs_guetzli.jpg');
            /*if (item.width > item.height) return 'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_75_guetzli.jpg');
            return 'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg');*/
        },
        reload() {
            this.items = this.getItems();
        },
        getItems() {
            this.dupeCounter = {};
            this.tags = ["favourites", "unused", "deleted"];
            const items = this.getItemsByGroup(this.id);
            const grouped = this.groupItemsByTags(items);
            this.sortTags();
            this.tagIdx['unused'] = this.tags.length;
            return grouped;
        },
        sortTags() {
            this.tags.sort((a, b) => {
                if (a === "favourites") return -1;

                if (a === "deleted") return 1;

                if (a > b) return 1;
                if (a < b) return -1;
                return 0;
            });
        },

        view(item, idx, tag) {

            if (!this.$IAP.hasAccessToComponent('photos')) {
                this.showUpgrade();
                return;
            }
            let items = {};

            items = this.items;

            this.$emit("open", [idx, tag, items]);
        },
        getItemsByGroup(id) {
            let items = [];

            if (this.isDev) {
                // Build origItems list
                // items = MediaList.filter((item) => item.groups.includes(id) || item.groups.includes(-1));
                items = MediaList.filter((item) => item.groups.includes(id));

                const itemSet = new Set();
                items.forEach(item => {
                    if (item.tags[0].substring(0,2) === "x_") return;
                    itemSet.add(item.src);
                });

                items = items.filter((item) => {
                     return item.tags[0] !== 'deleted____' && (item.tags[0].substring(0,2) !== "x_" || !itemSet.has(item.src));
                });

                items = this.flagDuplicates(items);

                // Override tag names
                if (localStorage.getItem('overrideTagNames')) {
                    const overrideTagNames = JSON.parse(localStorage.getItem('overrideTagNames'));
                    items.forEach((item) => {
                        const tag = item.tags[0];
                        if (typeof (overrideTagNames[String(this.id)]) !== 'undefined' && typeof overrideTagNames[String(this.id)][tag] !== "undefined") item.tags = [overrideTagNames[String(this.id)][tag]];
                    });
                }

                if (localStorage.getItem('overrideTags')) {
                    const overrideTags = JSON.parse(localStorage.getItem('overrideTags'));
                    items.forEach((item) => {
                        if (typeof overrideTags[String(item.id)] !== "undefined") item.tags = [overrideTags[String(item.id)]];
                    });
                }

                if (localStorage.getItem('overrideOrdering')) {
                    const overrideOrdering = JSON.parse(localStorage.getItem('overrideOrdering'));
                    items.forEach((item) => {
                        if (typeof overrideOrdering[String(item.id)] !== "undefined") item.ordering = overrideOrdering[String(item.id)];
                    });
                }
            } else {
                items = MediaList.filter((item) => item.groups.includes(id) && item.tags[0].substring(0,2) !== 'x_' && item.tags[0] !== 'deleted');
            }

            return items.sort((a,b)=>{
                if (a.ordering > b.ordering) return 1;
                if (a.ordering < b.ordering) return -1;
                return 0;
            });
        },

        flagDuplicates(items) {
            const filteredItems = [];
            items.forEach(item => {
                if (!this.dupeCounter.hasOwnProperty(item.src)) {
                    this.dupeCounter[item.src] = 0;
                    filteredItems.push(item);
                }
                this.dupeCounter[item.src]++;
            });
            return filteredItems;
        },

        groupItemsByTags(items) {
            const grouped = {};
            grouped['favourites'] = [];

            items.forEach(item => {
                const favved = this.isFavved("favvedGalleryMedia", item.src);
                if (favved) {
                    grouped['favourites'].push(item);
                    // return; // add favved items to favourites and the original group
                }
                const tag = item.tags[0] || 'photos';
                if (typeof grouped[tag] === "undefined") {
                    if (!this.tags.includes(tag)) this.tags.push(tag);
                    grouped[tag] = [];
                }
                grouped[tag].push(item);
            });

            this.tagIdx = {};
            let currentIdx = 0;
            this.tags.forEach((tag) => {
                if(typeof grouped[tag] === "undefined") grouped[tag] = [];
                this.tagIdx[tag] = currentIdx;
                currentIdx += grouped[tag].length;
            });

            return grouped;
        },

        updateOrdering(tag) {
            const items = document.querySelectorAll(".pm-gallery-media-grid-thumb");
            let i = 0;
            const orderingMap = new Map();
            let overrideOrdering = {};
            if (localStorage.getItem('overrideOrdering')) overrideOrdering = JSON.parse(localStorage.getItem('overrideOrdering'));
            const srcs = [];

            items.forEach(item => {
                if (item.dataset.tag !== tag) return;
                overrideOrdering[item.dataset.id] = i;
                orderingMap.set(parseInt(item.dataset.id), i);
                i++;
                srcs.push(item.dataset.src);
            });

            this.items[tag].forEach((item) => {
                if (orderingMap.has(item.id)) item.ordering = orderingMap.get(item.id);
            });

            localStorage.setItem('overrideOrdering', JSON.stringify(overrideOrdering));
            this.orderingUpdated = true;
        },
    },
};
</script>
